import { HiOutlineSquare3Stack3D } from "react-icons/hi2";
import * as React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Stack from "@mui/material/Stack";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {Link} from "react-router-dom";
import styles from "./BreadCrumb.module.css";

// here button is a component that you can pass as a prop
export default function BreadCrumb({ array,style,className,button,icon }) {
  const breadcrumbs = array.map((item, index) =>
    index === array.length - 1 ? (
      <h4 className="m-0 text-capitalize">{item.title}</h4>
    ) : (
      <Link
        key={index}
        color="inherit"
        to={item.link}
        style={{ fontSize: "13px", textDecoration: "none",textTransform:"capitalize" }}
      >
        <h4 className="m-0 text-capitalize">{item.title}</h4>
      </Link>
    )
  );

  return (
    <div style={style} className={`w-100 bg-white py-3 px-4 ${className} ${styles.breadCrumb} breadCrumb`}>
      <Stack spacing={2} direction={"row "} alignItems="center" gap={2}>
        <div className={styles.mainIcon}>
          {icon?<span>{icon}</span>:<HiOutlineSquare3Stack3D size={25} color="#0BD5FE"/>} {/* Main Icon */}
        </div>
        <Breadcrumbs
          style={{alignItems:"center"}}
          separator={<NavigateNextIcon fontSize="large" className={styles.separatorIcon}/>}
          aria-label="breadcrumb"
        >
          {breadcrumbs} {/* Breadcrumbs */}
        </Breadcrumbs>
        {button && <div className="ms-auto">{button}</div>} {/* Button */}
      </Stack>
    </div>
  );
}

// Example array
// const array = [
//   { title: "Core", link: "/material-ui/getting-started/installation/" },
//   { title: "Breadcrumb", link: "/material-ui/getting-started/installation/" },
// ];